import { Reducer } from 'redux';
import { KnownAction } from './quotesActions';
import { QuotesState, Tbody } from './quotesModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<QuotesState> = (state: QuotesState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = { myQuotes: new Array<Tbody>() };
    }
    // console.log('something works')
    switch (action.type) {
        case 'SET_QUOTES':
            return Object.assign({}, state, { myQuotes: action.myQuotes });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/quotes/quotesReducers.ts